module.exports = __webpack_public_path__ + "img/checkmark-sea.c304d59.svg";